// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TknLuSeoAggkXCriXDyFgw\\=\\=>span{border-radius:50%}", "",{"version":3,"sources":["webpack://./resources/react/Components/ui/AIColorInput.module.css"],"names":[],"mappings":"AACI,iCACI,iBACJ","sourcesContent":[".swatch {\n    >span {\n        border-radius: 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"swatch": "TknLuSeoAggkXCriXDyFgw=="
};
export default ___CSS_LOADER_EXPORT___;
